module.exports = __webpack_public_path__ + "static/media/RS.dc867a5f.svg";